import { useMemo } from 'react';
import { MultiValue } from 'react-select';
import { InputSearch } from '../../../shared/components';
import { FrontendFilterValue } from '../../../types/filters.type';
import { DelimiterRules } from '../../../utils/pasteValueHandler';
import useFilterStore from '../../../components/streetview/filterStore';
import useToastStore from '../../../components/app-layout/toastStore';

interface InputSearchContainerProps {
  searchOptions: MultiValue<FrontendFilterValue>,
  title: string,
  label: string,
  labelId: string,
  placeholder: string,
  placement: 'top' | 'auto' | 'bottom',
  delimiterRules: DelimiterRules
}

export default function InputSearchContainer({
  searchOptions,
  title,
  label,
  labelId,
  placeholder,
  placement,
  delimiterRules,
}: Readonly<InputSearchContainerProps>) {
  const selectedFilters = useFilterStore((state) => state.selectedFilters);
  const setSelectedFilters = useFilterStore((state) => state.setSelectedFilters);
  const selectedFilterValues = useMemo(() => selectedFilters[title]?.[labelId]?.selectedValues || [], [selectedFilters, title, labelId]);
  const handleChange = (values: FrontendFilterValue[]) => {
    setSelectedFilters(title, labelId, label, values);
  };
  const handleUnmatchedPaste = (unmatched: string[]) => {
    useToastStore.getState().showToast(`Some values were not found: ${unmatched.join(', ')}`, 'error');
  };

  return (
    <InputSearch
      searchOptions={searchOptions}
      selectedValues={selectedFilterValues}
      onChange={handleChange}
      onUnmatchedPaste={handleUnmatchedPaste}
      label={label}
      labelId={labelId}
      placeholder={placeholder}
      placement={placement}
      delimiterRules={delimiterRules}
    />
  );
}
